import { useState, useEffect } from "react";
import { Button, Box, TextField } from "@mui/material";
import { UseTargetLocation } from "./UseTargetLocation";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";

function EditTargetLocation(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const location = useLocation();
  const [targetLocation, setTargetLocation] = useState();
  const { getLocationByID, validate, updateLocation } = UseTargetLocation();
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    if (location.state && location.state.id) {
      getLocationByID(location.state.id, (locationRes) => {
        setState(locationRes);
      });
    }
  }, []);

  const [state, setState] = useState({
    id: undefined,
    location: undefined,
  });

  const [errorState, setErrorState] = useState({
    location: false,
  });

  return (
    <Detail
      breadChilds={{
        title: "اطلاعات پایه",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/targetlocation" },
          {
            name: "ویرایش محل مصرف",
            url: "/targetlocation/edittargetlocation",
          },
        ],
      }}
    >
      {!targetLocation ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              sx={{ width: "100%" }}
              value={state.location ? state.location : ""}
              error={errorState.location}
              label="محل مصرف "
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, location: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  updateLocation(state, () => {
                    navigate("/targetlocation", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/targetlocation", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}

export default EditTargetLocation;
